import { initializeOnDomReady } from "@credit-acceptance/common-frontend";

import App from "./App";

initializeOnDomReady(App);
